import { defineComponent as n, openBlock as r, createBlock as l, unref as m, mergeProps as p, withCtx as c, createElementVNode as o } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconPromo",
  __name: "IconPromo",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const a = t;
    return (i, e) => (r(), l(m(d), p(a, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        o("path", { d: "M7.436 8.436a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5.771.484a.75.75 0 0 0-1.5 0v7.072a.75.75 0 0 0 1.5 0V8.92m-2.871 2.829a1 1 0 1 1-1.415 1.414 1 1 0 0 1 1.415-1.414m5.657 1.414a1 1 0 1 0-1.414-1.414 1 1 0 0 0 1.414 1.414" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M3.222 4.472a1.25 1.25 0 0 1 1.25-1.25h6.364a1.25 1.25 0 0 1 .884.366l8.692 8.692a1.25 1.25 0 0 1 0 1.768l-6.364 6.364a1.25 1.25 0 0 1-1.768 0L3.588 11.72a1.25 1.25 0 0 1-.366-.884V4.472m1.5.25v6.01l8.442 8.443 6.01-6.01-8.442-8.443h-6.01",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
